<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="switchStep" novalidate>
                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>

                        <div class="px-4">
                            <div class="row">
                                <div class="col-sm-8">

                                    <div v-if="resources == undefined" class="text-center dark">
                                        <div>Loading resources please wait</div>
                                    </div>
                                    <template v-esle>
                                        <div v-if="resources && resources !== undefined && resources.length > 0" class="panel shaded">
                                            <h5 class="border-bottom-lightest">What are the available resources for this product?</h5>

                                            <div class="form-group row">
                                                <div class="col-sm-12">
                                                    <table class="table narrow">
                                                        <thead>
                                                            <tr>
                                                                <th class="pl-3">Resource</th>
                                                                <th class="pl-3">Capacity limit</th>
                                                                <th class="pl-3">&nbsp;</th>
                                                                <th class="pl-3">&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(resource, index) in form.resources">
                                                                <td class="p-3">
                                                                    <v-select
                                                                        v-model="form.resources[index]"
                                                                        :options="resources"
                                                                        placeholder="- Select resource -"
                                                                        label="name"
                                                                        @input="updateResourcesList(resource, index)">
                                                                    </v-select>
                                                                </td>
                                                                <td class="pl-3">
                                                                    {{ fetchCapacity(resource) }}
                                                                </td>
                                                                <td>
                                                                    <i class="ico-delete largest medium pointer" @click="deleteRow(index, 'resources')"></i>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="addResource">
                                                        <i class="ico-add fs-smallest add-circle color-1"></i> Add new
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="resources && resources.length == 0" class="text-center dark">
                                            <div>Looks like you have no resources in your inventory :(</div>
                                            <button type="button" class="btn mt-3" @click="createResource">Create Resource</button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Steps from './ProductSteps'
    import extendedVSelect from '@/extends/vue-select'
    import { requiredIf, withParams, numeric } from 'vuelidate/lib/validators'
    import {eventHub} from '@/main'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 4,
                form: {
                    resources: [],
                    favoriteResourceId: null,
                    resourcesList: [],
                },
                selectedPayment: null,
                selectedDeposit: null,
                haveUserCreatedNewResource: 0, //this is just to make a watcher for async resources, so we can call it again
            }
        },
        created: function() {
            this.form = JSON.parse(JSON.stringify(this.getClonedItem));
            console.log(this.form.resources)

            eventHub.$on('updatedResources', () => {
                //this makes asyncComputed - resources run again
                this.haveUserCreatedNewResource++
            });
        },
        asyncComputed: {
            resources: {
                async get () {
                    try {
                        let response = await axios.get('/api/inventory/ListResource', { params: { supplierId: this.account.supplierId }});

                        if (response && response.status === 200 && response.data) {
                            // Map FK information through selects: for each ID found when editing, map
                            // the whole extra object for the dropdown
                            if(response.data.length > 0){
                                if (this.getSelectedItem) {
                                    response.data.forEach(resource => {
                                    });
                                }

                                // in case of no resources already associated with event, maybe set the [0] as associated?
                                //this.rebuildResourcesList(response.data);
                            }

                            return response.data;
                        }
                    }
                    catch (error) {
                        this.$toasted.error(error);
                    }

                },
                watch () {
                    this.haveUserCreatedNewResource
                }
            },
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'account'
            ])
        },
        methods: {
            ...mapActions([
                'openModal'
            ]),
            rebuildResourcesList: function(resourceArrFromApi) {
                if (this.form.resources === undefined) {
                    this.form.resources = [];
                }

                // For each resource we map (via async resources()), we must
                // check if that resource is on our resourcesList (when editing)
                // and rebuild our resources array from there.

                //FG
                //this is the rebuilt ressource array with the right structure, this will take the place of the one sent to the frontend by the APi
                //this happens because the API send the reources in one format but to send them to save they need to be on other format (as below)
                // correction - looks like what cares for API is the resourcesList not the resources array
                let tempRebuiltArr = []
                for (let apiResource of resourceArrFromApi) {
                    if (this.form.resourcesList !== undefined && this.form.resourcesList.includes(apiResource.id)) {
                        tempRebuiltArr.push(apiResource);
                    }
                }
                console.log(tempRebuiltArr);
                this.form.resources = tempRebuiltArr;
            },
            addResource: function() {
                console.log('resource added');
                if (this.form.resources === undefined) {
                    this.$set(this.form, 'resources', []);
                }
                this.form.resources.push(this.createEmptyResourceRow()); // ok
                this.$forceUpdate(); //fixes this: https://vuejs.org/v2/guide/list.html#Array-Change-Detection
            },
            createEmptyResourceRow: function() {
                return this.resources[0]
            },
            updateResourcesList: function(resource, index) {
                if (this.form.resourcesList === undefined) {
                    this.form.resourcesList = [];
                }

                //this.form.resources[index] = resource;
                this.form.resourcesList[index] = resource.id;


                //
                // let index = this.form.resourcesList.indexOf(resource.id);
                //
                // if (index == -1) {
                //     this.form.resourcesList.push(resource.id);
                //
                //     if (resource.isFavorite) {
                //         this.form.favoriteResourceId = resource.id;
                //     }
                // }

                this.$forceUpdate();

            },
            fetchCapacity: function(item) {
                return item ? item.availability : '-';
            },
            deleteRow: function(row, item) {
                // Deletes selected row
                // works for resources and schedules

                switch (item) {
                    case 'resources':
                        this.form.resources.splice(row, 1);
                        break;

                    default:
                        break;
                }
                this.$forceUpdate();
            },
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step) ) ? step : (this.currentStep - 1) });
            },
            nextStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
            },
            createResource: function() {
                this.openModal('ResourceAdd')
            }
        },
        components: {
            Steps,
            vSelect: extendedVSelect
        }
    }
</script>



// WEBPACK FOOTER //
// ProductResources.vue?31b02a9c